module.exports = __webpack_public_path__ + "media/images/emblems/Muenchwilen-blason-c8cd0f20991ba6745d3557ff66d7c9ca.png";